import { Text, View } from '@react-pdf/renderer'
import React from 'react'
import { DATE_FORMAT_DISPLAY, PDF_BLOCK_HEADING, PDF_BLOCK_TEXT, PDF_GRAY } from '../../../../constants'
import PdfTextBlockBottom from '../TextBlocks/PdfTextBlockBottom'
import PdfTextBlockLeft from '../TextBlocks/PdfTextBlockLeft'
import PdfTextBlockTop from '../TextBlocks/PdfTextBlockTop'
import { DateTime } from 'luxon'

const HeaderDetails = ({data}) => {
    // const data = [
    //     {
    //         model: "TA5019",
    //         part: "T295",
    //         orders: [
    //             {
    //                 group: "1",
    //                 order_number: "ACQP-20-24-1853",
    //                 order_date: "2024-01-01",
    //                 production_step: "",
    //                 color: "10105"
    //             },
    //             {
    //                 group: "2",
    //                 order_number: "ACQP-20-24-1853",
    //                 order_date: "2024-10-06",
    //                 production_step: "",
    //                 color: "22222"
    //             },
    //             {
    //                 group: "2",
    //                 order_number: "ACQP-20-24-1853",
    //                 order_date: "2024-10-06",
    //                 production_step: "",
    //                 color: "22222"
    //             },
    //             {
    //                 group: "2",
    //                 order_number: "ACQP-20-24-1853",
    //                 order_date: "2024-10-06",
    //                 production_step: "",
    //                 color: "22222"
    //             },
    //             {
    //                 group: "2",
    //                 order_number: "ACQP-20-24-1853",
    //                 order_date: "2024-10-06",
    //                 production_step: "",
    //                 color: "22222"
    //             },
    //             {
    //                 group: "2",
    //                 order_number: "ACQP-20-24-1853",
    //                 order_date: "2024-10-06",
    //                 production_step: "",
    //                 color: "22222"
    //             },
    //         ]
    //     },
    // ]
    return (
            <View
                style={{
                    flexDirection: "row",
                    display: "flex",
                    alignItems: "stretch",
                    marginBottom: "15px"
                    // marginBottom: "20px"
                }}
            >
                <View
                    style={{
                        width: "10%",
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    <PdfTextBlockTop
                        disableBottomBorder={false}
                        fontSmaller
                        title="Model"
                        fontNormal
                        text={data.orders[0].job_order_meta.model}
                        disableRightBorder={true}
                    />
                </View>
                <View
                    style={{
                        width: "10%",
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    <PdfTextBlockTop
                        disableBottomBorder={false}
                        fontSmaller
                        fontNormal
                        title="Part"
                        text={data.orders[0].job_order_meta.part}
                        disableRightBorder={true}
                    />
                </View>
                <View
                    style={{
                        width: "80%"
                    }}
                >
                    {
                        data.orders.map((order, orderIndex) => (
                            <View style={{
                                width: "100%",
                                flexDirection: "row",
                            }}>
                                <View
                                    style={{
                                        width: "10%",
                                        display: "flex",
                                        flexDirection: "column"
                                    }}
                                >
                                    <PdfTextBlockTop
                                        disableRightBorder
                                        fontNormal
                                        fontSmaller
                                        disableBottomBorder={orderIndex === data.orders.length - 1 ? false : true}
                                        hideHeading={orderIndex === 0 ? false : true}
                                        title="Group"
                                        text={"*"}
                                    />
                                </View>
                                <View
                                    style={{
                                        width: "30%",
                                        display: "flex",
                                        flexDirection: "column"
                                    }}
                                >
                                    <PdfTextBlockTop
                                        disableRightBorder
                                        fontNormal
                                        fontSmaller
                                        disableBottomBorder={orderIndex === data.orders.length - 1 ? false : true}
                                        hideHeading={orderIndex === 0 ? false : true}
                                        title="Order Num"
                                        text={order.order.key}
                                    />
                                </View>
                                <View
                                    style={{
                                        width: "20%",
                                        display: "flex",
                                        flexDirection: "column"
                                    }}
                                >
                                    <PdfTextBlockTop
                                        disableRightBorder
                                        fontNormal
                                        fontSmaller
                                        disableBottomBorder={orderIndex === data.orders.length - 1 ? false : true}
                                        hideHeading={orderIndex === 0 ? false : true}
                                        title="Order Date"
                                        text={order.order.date ? DateTime.fromISO(order.order.date).toFormat(DATE_FORMAT_DISPLAY) : "-"}
                                    />
                                </View>
                                <View
                                    style={{
                                        width: "25%",
                                        display: "flex",
                                        flexDirection: "column"
                                    }}
                                >
                                    <PdfTextBlockTop
                                        disableRightBorder
                                        fontNormal
                                        fontSmaller
                                        disableBottomBorder={orderIndex === data.orders.length - 1 ? false : true}
                                        hideHeading={orderIndex === 0 ? false : true}
                                        title="Prod. Step"
                                        text={data.production_step ? data.production_step : "-"}
                                    />
                                </View>
                                <View
                                    style={{
                                        width: "15%",
                                        display: "flex",
                                        flexDirection: "column"
                                    }}
                                >
                                    <PdfTextBlockTop
                                        fontNormal
                                        fontSmaller
                                        disableBottomBorder={orderIndex === data.orders.length - 1 ? false : true}
                                        hideHeading={orderIndex === 0 ? false : true}
                                        title="Color"
                                        text={order.job_order_meta.color}
                                    />
                                </View>
                            </View>

                        ))
                    }
                </View>
            </View>
    )
}

export default HeaderDetails